/* tslint:disable */
/* eslint-disable */
/**
 * Cryptix API
 * The Cryptix API is organized around [REST](https://wikipedia.org/wiki/REST).  ## HTTP response status codes |Status Code | Description| |---|---| |[200 OK](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/200) | The request is successful.| |[202 Accepted](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/202) | The server accepted the request and will execute it later. | |[401 Unauthorized](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/401)| Indicates that the client request has not been completed because it lacks valid authentication credentials for the requested resource.| |[403 Forbidden](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/403)| Indicates that the server understands the request but refuses to authorize it.| |[404 Not Found](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/404)| Indicates that the server cannot find the requested resource.| |[405 Method Not Allowed](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/405)| Indicates that the server knows the request method, but the target resource doesn\'t support this method.| |[422 Unprocessable Content](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/422)| Returned when the validation of the resource fails on POST or PUT requests. Response contains errors field with a list of errors.| |[429 Too Many Requests](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/429)| Indicates the user has sent too many requests in a given amount of time (\"rate limiting\").| |[500 Internal Server Error](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/500)| Server error.|  ## Error Codes |Error Code | Description| |---|---| | `authentication_required` | Indicates that the client request has not been completed because it lacks valid authentication credentials for the requested resource. | | `rate_limit_exceeded`     | Indicates the user has sent too many requests in a given amount of time (\"rate limiting\"). | | `validation_error`     | Request validation error. Response contains errors field with a list of errors. | | `insufficient_balance` | The operation could not be completed because the associated account does not have a sufficient balance available. Create a new operation using an amount less than or equal to the account\'s available balance. | | `amount_too_small`     | The specified amount is less than the minimum amount allowed. Use a higher amount (or change fee payer) and try again. | --- 
 *
 * The version of the OpenAPI document: v2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from "./configuration";
import { RequiredError,　RequestArgs } from "./base";
import { AxiosInstance } from 'axios';

/**
 *
 * @export
 */
export const DUMMY_BASE_URL = 'https://example.com'

/**
 *
 * @throws {RequiredError}
 * @export
 */
export const assertParamExists = function (functionName: string, paramName: string, paramValue: unknown) {
    if (paramValue === null || paramValue === undefined) {
        throw new RequiredError(paramName, `Required parameter ${paramName} was null or undefined when calling ${functionName}.`);
    }
}

/**
 *
 * @export
 */
export const setApiKeyToObject = async function (object: any, keyParamName: string, configuration?: Configuration) {
    if (configuration && configuration.apiKey) {
        const localVarApiKeyValue = typeof configuration.apiKey === 'function'
            ? await configuration.apiKey(keyParamName)
            : await configuration.apiKey;
        object[keyParamName] = localVarApiKeyValue;
    }
}

/**
 *
 * @export
 */
export const setBasicAuthToObject = function (object: any, configuration?: Configuration) {
    if (configuration && (configuration.username || configuration.password)) {
        object["auth"] = { username: configuration.username, password: configuration.password };
    }
}

/**
 *
 * @export
 */
export const setBearerAuthToObject = async function (object: any, configuration?: Configuration) {
    if (configuration && configuration.accessToken) {
        const accessToken = typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        object["Authorization"] = "Bearer " + accessToken;
    }
}

/**
 *
 * @export
 */
export const setOAuthToObject = async function (object: any, name: string, scopes: string[], configuration?: Configuration) {
    if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
            ? await configuration.accessToken(name, scopes)
            : await configuration.accessToken;
        object["Authorization"] = "Bearer " + localVarAccessTokenValue;
    }
}

/**
 *
 * @export
 */
export const setSearchParams = function (url: URL, ...objects: any[]) {
    const searchParams = new URLSearchParams(url.search);
    for (const object of objects) {
        for (const key in object) {
            if (Array.isArray(object[key])) {
                searchParams.delete(key);
                for (const item of object[key]) {
                    searchParams.append(key, item);
                }
            } else {
                searchParams.set(key, object[key]);
            }
        }
    }
    url.search = searchParams.toString();
}

/**
 *
 * @export
 */
export const serializeDataIfNeeded = function (value: any, requestOptions: any, configuration?: Configuration) {
    const nonString = typeof value !== 'string';
    const needsSerialization = nonString && configuration && configuration.isJsonMime
        ? configuration.isJsonMime(requestOptions.headers['Content-Type'])
        : nonString;
    return needsSerialization
        ? JSON.stringify(value !== undefined ? value : {})
        : (value || "");
}

/**
 *
 * @export
 */
export const toPathString = function (url: URL) {
    return url.pathname + url.search + url.hash
}

/**
 *
 * @export
 */
export const createRequestFunction = function (axiosArgs: RequestArgs, globalAxios: AxiosInstance, BASE_PATH: string, configuration?: Configuration) {
    return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {...axiosArgs.options, url: (configuration?.basePath || basePath) + axiosArgs.url};
        return axios.request(axiosRequestArgs);
    };
}
